export const HEIGHT_LOWER_THRESHOLD = 410;
